<div class="modal-container" data-testid="company-invite-modal">
  <div class="modal-header">
    <span>{{ 'modal.invite.member.title' | translate }}</span>
    <div class="modal-header-close-btn" (click)="abortModal()">
      <span class="icon-close"></span>
    </div>
  </div>
  <div class="seperator">
    <hr />
  </div>
  <div class="modal-body">
    <span *ngIf="!errorMessage">
      {{ 'modal.invite.member.instructions' | translate }}
    </span>
    <span class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </span>
    <div class="company-share-link-group">
      <label for="company-share-link">{{
        'modal.invite.member.share_link' | translate
      }}</label>
      <div class="copy-link-input">
        <div class="group">
          <input
            disabled
            type="text"
            name="company-share-link"
            id="company-share-link"
            class="link-copy-input"
            [placeholder]="
              link.length > 40 ? (link | slice: 0 : 40) + '...' : link
            "
          />
          <span class="copy-link" (click)="copyLink()"></span>
        </div>
        <app-response-banner
          [success]="true"
          [invisible]="!isCopied"
          successMessage="{{ 'modal.invite.member.copied' | translate }}"
        ></app-response-banner>
      </div>
    </div>
    <form [formGroup]="form" class="send-email" (ngSubmit)="sendInvitation()">
      <label>{{ 'modal.invite.member.invite_email' | translate }}</label>
      <app-qs-input
        class="input"
        testId="company-invite-email"
        [controllerName]="'email'"
        label="{{ 'modal.invite.member.email_label' | translate }}"
        placeholder="{{ 'modal.invite.member.email_placeholder' | translate }}"
      ></app-qs-input>
      <app-button
        [medium]="true"
        testId="company-invite-send"
        [title]="'modal.invite.member.send_invitation' | translate"
        [disabled]="form.invalid"
      ></app-button>
    </form>
  </div>
</div>
